import * as types from "@/store/types";
import { mapActions, mapGetters } from "vuex";
const DepositConfirmationCard = () =>
  import("@/components/OperationsPage/Deposit/DepositConfirmationCard/index");
const UserRegisteredCard = () =>
  import("@/components/BankCard/UserRegisteredCard/index");
const NotAvailableCard = () =>
  import("@/components/BankCard/NotAvailableCard/index");
const NumberInput = () => import("@/components/NumberInput/index");
const AddCard = () => import("@/components/BankCard/AddCard/index");
import { OperationService } from "@/services";
import Num2persian from "num2persian";
import $thousandMask from "@/mixins/thousandMask";
import $exponent from "@/mixins/exponent";
export default {
  name: "online",
  components: {
    DepositConfirmationCard,
    UserRegisteredCard,
    NotAvailableCard,
    NumberInput,
    AddCard
  },
  props: [],
  mixins: [$thousandMask, $exponent],
  data() {
    return {
      orderAmount: 0,
      baseUrl: process.env.VUE_APP_BASE_URL,
      publicUrl: process.env.VUE_APP_PUBLIC_BASE_URL,
      gateways: [],
      gatewayId: null,
      selectedGateway: null,
      value: "",
      amountPrice: 0,
      confirmDialog: false,
      notAvailableCardDialog: false,
      showMinLimitError: false,
      showMaxLimitError: false,
      minimum_amount: 0,
      waiteForRequest: false,
      addCardDialog: false,
      cartsBank: [],
      selectedCartBankId: ""
    };
  },
  computed: {
    ...mapGetters({
      getWallets: types.operations.getters.GET_WALLET,
      getExchanges: types.wallets.getters.GET_EXCHANGE_WALLETS
    }),
    handleNumber2Persian() {
      let str = this.amountPrice.toString();
      str = str?.replace(/,/gi, "");
      return Num2persian(parseInt(parseInt(str) / 10));
    },
    availableAmount() {
      if (this.selectedGateway) {
        return this.selectedGateway.max_amount.toString();
      }
    },
    // getWalletIrr() {
    //   if (Object.entries(this.getWallets).length > 0) {
    //     return this.getWallets.wallets.find(elem => {
    //       if (elem.currency.iso === "IRR") {
    //         return elem;
    //       }
    //     });
    //   }
    // },
    IrrExchange() {
      let min;
      // iso = "";
      if (
        Object.entries(this.getExchanges).length > 0 &&
        Object.entries(this.getWallets).length > 0
      ) {
        this.getExchanges.data["IRR"].find(elem => {
          if (elem.to === "IRR") {
            //TODO: need refactor
            min = parseFloat(elem.minimum_amount_to);
            this.minimum_amount = elem.minimum_amount_to;
            // iso = elem.to;
          }
        });
        if (this.amountPrice === 0 || this.amountPrice === "") {
          return "";
        } else if (this.amountPrice < min) {
          // return `${this.$tc(
          //   "operationsPage.deposit.category.rial.online.minBalanceError",
          //   0,
          //   { min: this.$thousandMask(min) }
          // )}`;
        } else {
          return "";
        }
      }
    },
    setErrorStep() {
      if (this.selectedGateway) {
        if (
          this.amountPrice >= this.selectedGateway.min_amount &&
          this.amountPrice <= this.selectedGateway?.max_amount
        ) {
          return false;
        } else {
          return true;
        }
      }
    },
    setInputErrorStep() {
      if (this.selectedGateway) {
        if (this.amountPrice >= this.selectedGateway.min_amount) return false;
        else return true;
      }
    }
  },
  mounted() {
    this.getGatewaysService();
    this.checkOutIpg();
  },
  methods: {
    ...mapActions({
      setBankCard: types.operations.actions.SET_BANK_CARD
    }),
    setAmountPrice(event) {
      // this.amountPrice = event;
      this.showMaxLimitError = false;
      this.showMinLimitError = false;
      this.showMinLimitError = event < this.selectedGateway.min_amount;
      this.showMaxLimitError = event > this.selectedGateway?.max_amount;
      // this.amountPrice = event;
    },
    setConfirmDialog(event) {
      this.confirmDialog = event;
    },
    getGatewaysService() {
      OperationService.getGateways()
        .then(response => {
          this.gateways = response.data.data;
          response.data.data.forEach(elem => {
            if (elem.is_default === true) {
              this.gatewayId = elem;
            }
          });
        })
        .then(() => {
          this.setSelectedGateway(this.gatewayId);
        });
    },
    setSelectedGateway(gateway) {
      this.selectedGateway = this.gateways.find(el => el.id === gateway.id);
      this.showMinLimitError =
        this.amountPrice < this.selectedGateway.min_amount;
      this.showMaxLimitError =
        this.amountPrice > this.selectedGateway?.max_amount;
      // this.amountPrice = 0;
    },
    checkOutIpg() {
      // this.confirmDialog = true;
      this.getBankCardService().then(response => {
        this.setBankCard(response);
        if (response.length > 0) {
          this.notAvailableCardDialog = false;
        } else {
          this.notAvailableCardDialog = true;
        }
      });
    },
    getBankCardService() {
      return OperationService.getBankCard().then(response => {
        this.cartsBank = response.data.data;
        return response.data.data;
      });
    },
    addClassForGetway(index) {
      if (!this.$vuetify.breakpoint.smAndDown) {
        if (this.$vuetify.rtl) {
          return index % 2 === 0
            ? "gateway-padding-left"
            : "gateway-padding-right";
        } else {
          return index % 2 === 0
            ? "gateway-padding-right"
            : "gateway-padding-left";
        }
      } else {
        if (this.$vuetify.rtl) {
          return index % 2 === 0 ? "pe-3" : "ps-3";
        } else {
          return index % 2 === 0 ? "ps-3" : "pe-3";
        }
      }
    },
    goToOfflineTab() {
      this.$router.push({
        query: { from: this.$route.query.from, paymentType: "paymentID" }
      });
    },
    waiteRequest(value) {
      this.waiteForRequest = value;
    },
    showAddCardDialog() {
      this.addCardDialog = true;
    },

    handleIpg() {
      this.waiteForRequest = true;
      let dataObject = {
        amount: this.amountPrice,
        psp_id: this.gatewayId.id,
        card_id: this.selectedCartBankId
      };
      OperationService.depositIRR(dataObject)
        .then(response => {
          window.location.replace(response.data.data.url);
        })
        .finally(() => {
          this.waiteForRequest = false;
        });
    },
    truncateCartNumber(cartNumber) {
      return cartNumber.slice(-4) + "-****-****-" + cartNumber.slice(0, 4);
    }
  }
};
